import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilAtendente } from '../usuario/usuario-perfil';


/** Acessos permitidos ao cadastro de grupos econômicos */
export const acessosClienteGrupoEconomico: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilAtendente];

@Injectable()
export class CanActivateClienteGrupoEconomico implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosClienteGrupoEconomico);
    }
}
